import { IonGrid, IonRow } from '@ionic/react';
import equal from 'deep-equal';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { createEnumParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import TimePeriodField from '@components/fields/TimePeriodField';
import styles from '@components/forms/AdminJourneyFilters.module.css';
import Form from '@components/forms/Form';
import { TimePeriodEnum } from '@typing/Enums';

type FormData = {
  endDate?: string | null;
  startDate?: string | null;
  timePeriod?: TimePeriodEnum | null;
};

type Props = {
  filters: FormData;
  onChange: (filterValues: FormData) => void;
};

const CareProfileChangeFilters = ({ filters, onChange }: Props) => {
  const timePeriodParam = createEnumParam<TimePeriodEnum>(Object.values(TimePeriodEnum));

  const [query, setQuery] = useQueryParams({
    endDate: withDefault({ ...StringParam, urlName: 'cpChangeEndDate' }, filters.endDate),
    startDate: withDefault({ ...StringParam, urlName: 'cpChangeStartDate' }, filters.startDate),
    timePeriod: withDefault({ ...timePeriodParam, urlName: 'cpChangeTimePeriod' }, filters.timePeriod)
  });

  const defaultValues: FormData = query;

  const form = useForm<FormData>({
    defaultValues,
    mode: 'onChange'
  });

  const endDate = form.watch('endDate');
  const startDate = form.watch('startDate');
  const timePeriod = form.watch('timePeriod');

  useEffect(() => {
    const values = { endDate, startDate, timePeriod };
    if (!equal(values, filters)) {
      setQuery(values);
      onChange(values);
    }
  }, [endDate, filters, form, onChange, setQuery, startDate, timePeriod]);

  return (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Form className={styles.form} hookForm={form} onSubmit={() => {}}>
      <IonGrid>
        <IonRow className="ion-align-items-center">
          <TimePeriodField form={form} />
        </IonRow>
      </IonGrid>
    </Form>
  );
};

export default CareProfileChangeFilters;
